var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapse, lighten, Box } from "@mui/material";
import TableRow from "../TableRow";
import TableCell, { MemoTableCell } from "../TableCell";
import Text from "../../../../Atoms/Text";
import { COLORS } from "../../../../../constants";
import WYSIWYG from "../../../WYSIWYG";
import slate from "remark-slate";
import markdown from "remark-parse";
import { unified } from "unified";
import { useEffect, useState } from "react";
var CollapseRow = function (_a) {
    var _b;
    var rowLength = _a.rowLength, row = _a.row, memoCells = _a.memoCells, collapseRowClickHandler = _a.collapseRowClickHandler, open = _a.open, canCollapse = _a.canCollapse;
    var content = (_b = row.rowData.collapse) === null || _b === void 0 ? void 0 : _b.content;
    var _c = __read(useState([]), 2), descendants = _c[0], setDescendants = _c[1];
    // return null if no collapse content is available
    if (!(canCollapse && row.rowData.collapse)) {
        return null;
    }
    useEffect(function () {
        parseMarkdownToSlate();
    }, []);
    /**
     * convert markdown to something slate understands
     */
    var parseMarkdownToSlate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, unified().use(markdown).use(slate).process(content)];
                case 1:
                    data = _b.sent();
                    setDescendants(data.result);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    console.error("failed to parse content text.");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var CellComponent = memoCells ? MemoTableCell : TableCell;
    return (_jsxs(TableRow, __assign({ "data-testid": "".concat(row.id, "-row-collapse"), sx: {
            background: lighten(COLORS.LIGHT_GREY, 0.7),
            borderBottom: "1px solid ".concat(lighten(COLORS.BLACK, 0.9)),
        } }, { children: [_jsx(CellComponent, __assign({ colSpan: 2, columnName: "collapse-content", cellId: row.id, clickHandler: collapseRowClickHandler, data: row.data, collapseOpen: open, style: { padding: 0, verticalAlign: "top" } }, { children: _jsx(Collapse, __assign({ in: open, timeout: "auto", unmountOnExit: true }, { children: _jsx(Text, __assign({ variant: "subtitle2", emphasis: "medium", sx: { py: 3, pl: 7.5 } }, { children: "Notes" })) })) })), _jsx(CellComponent, __assign({ colSpan: rowLength - 2, columnName: "collapse-content-wysiwyg", cellId: row.id, data: row.data, memoComparitor: content, collapseOpen: open, clickHandler: collapseRowClickHandler, style: { padding: 0 } }, { children: _jsx(Collapse, __assign({ in: open, timeout: "auto", unmountOnExit: true }, { children: _jsx(Box, __assign({ pr: 7.5, pl: 4, py: 4 }, { children: _jsx(WYSIWYG, { readOnly: true, forceUpdateData: descendants }) })) })) }))] })));
};
export default CollapseRow;
